import React, { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Eye } from "lucide-react";

export function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve({
      b64: r.result?.toString() || "",
      name: file.name,
      content_type: file.type || "application/octet-stream",
    });
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export function fileKind(doc) {
  const ct = (doc.content_type || "").toLowerCase();
  const name = (doc.file_name || "").toLowerCase();
  if (ct.includes("pdf") || name.endsWith(".pdf")) return "pdf";
  if (/image\/(jpe?g|png)/.test(ct) || /\.(jpe?g|png)$/.test(name)) return "image";
  return null;
}

export function PreviewButton({ doc, fileUrl, testid, dialogTestid = "hse-image-preview-dialog", imgTestid = "hse-image-preview", className = "" }) {
  const [img, setImg] = useState(null);
  const kind = fileKind(doc);
  if (!kind) return null;
  const preview = async () => {
    const win = kind === "pdf" ? window.open("", "_blank") : null;
    try {
      const sep = fileUrl.includes("?") ? "&" : "?";
      const res = await api.get(`${fileUrl}${sep}inline=true`, { responseType: "blob" });
      const type = kind === "pdf" ? "application/pdf" : (doc.content_type || res.headers?.["content-type"]);
      const url = URL.createObjectURL(new Blob([res.data], { type }));
      if (win) win.location.href = url; else setImg(url);
    } catch {
      win?.close();
      toast.error("Belge açılamadı");
    }
  };
  const close = () => { if (img) URL.revokeObjectURL(img); setImg(null); };
  return (
    <>
      <Button variant="outline" className={`rounded-none border-2 border-[#09090B] ${className}`} onClick={preview}
        title="Önizle" data-testid={testid}>
        <Eye size={14} />
      </Button>
      <Dialog open={!!img} onOpenChange={(v) => { if (!v) close(); }}>
        <DialogContent className="rounded-none border-2 border-[#09090B] bg-white max-w-4xl" data-testid={dialogTestid}>
          <DialogHeader>
            <DialogTitle className="font-heading text-lg tracking-tight break-all">{doc.file_name}</DialogTitle>
          </DialogHeader>
          {img && <img src={img} alt={doc.file_name} className="max-h-[75vh] w-full object-contain" data-testid={imgTestid} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
